export default {"src":"/_next/static/image/public/images/icons1/2.a5890f087c29c0107e01fb4dc7b92133.svg","height":26,"width":20};